import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function HomeAdvisor(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="#F19200" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <path
        d="M14.263 11.9533L14.0071 11.6974L10.1407 7.83105L6.7998 11.172V14.4186C6.7998 14.8901 7.19048 15.2808 7.66198 15.2808H11.6091L14.6267 18.2984V15.2808H16.3107C16.7822 15.2808 17.1729 14.8901 17.1729 14.4186V11.9533H14.6133H14.263Z"
        fill="white"
      />
      <path
        d="M14.5867 5.87769H9.41367L4.2002 11.0912H5.68206L10.1546 6.61862L14.6271 11.0912H19.8002L14.5867 5.87769Z"
        fill="white"
      />
    </svg>
  );
}

HomeAdvisor.propTypes = propTypes;
HomeAdvisor.defaultProps = defaultProps;

export default HomeAdvisor;
